import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\AnalyticsDashboard\ExportInvoiceItemDetailRowsController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/ExportInvoiceItemDetailRowsController.php
* @route '/api/analytics/invoice-item/detail-rows/export'
*/
const ExportInvoiceItemDetailRowsController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ExportInvoiceItemDetailRowsController.url(options),
    method: 'post',
})

ExportInvoiceItemDetailRowsController.definition = {
    methods: ["post"],
    url: '/api/analytics/invoice-item/detail-rows/export',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AnalyticsDashboard\ExportInvoiceItemDetailRowsController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/ExportInvoiceItemDetailRowsController.php
* @route '/api/analytics/invoice-item/detail-rows/export'
*/
ExportInvoiceItemDetailRowsController.url = (options?: RouteQueryOptions) => {
    return ExportInvoiceItemDetailRowsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AnalyticsDashboard\ExportInvoiceItemDetailRowsController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/ExportInvoiceItemDetailRowsController.php
* @route '/api/analytics/invoice-item/detail-rows/export'
*/
ExportInvoiceItemDetailRowsController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ExportInvoiceItemDetailRowsController.url(options),
    method: 'post',
})

export default ExportInvoiceItemDetailRowsController